<template>
<div>
  <InternalForm v-if="showForm" @close-form="setFormShow(false, $event)" :data="row" />
  <InternalList v-if="!showForm" @show-form="setFormShow(true)"
                @edit-template="setData" @delete-template="setDelete" />
</div>
</template>

<script>
import InternalList from '@/layouts/components/partners/Internal/InternalList'
import InternalForm from '@/layouts/components/partners/Internal/InternalForm'
import {mapActions} from 'vuex'
export default {
  name: 'Internal',
  components: {InternalForm, InternalList},
  data: () => ({
    showForm: false,
    row: false
  }),
  methods: {
    ...mapActions('partners', ['deletePartner']),
    setFormShow (show, event) {
      console.log(event)
      this.showForm = show
      if (!event) this.row = false
      if (event) window.setTimeout(() => {
        this.showForm = true
      }, 100)
    },
    setData (row) {
      this.showForm = true
      this.row = row
    },
    setDelete (row) {
      console.log(JSON.parse(JSON.stringify(row)))
      this.deletePartner(row.template_tp_id)
    }
  }
}
</script>

<style scoped>

</style>
